<script>
// import Vue from 'vue'
import { Bar } from 'vue-chartjs';
import {changeFormatHelper, changeFormatWeek} from '../helper/datetimeHelper';

export default {
  name: 'line-chart',
  extends: Bar,
  props:{
    chartInfo: {
      type: Object,
      required: true,
    },
    typeChart:{
      type: String,
      default: 'day'
    },
    isFromSalaryChart: {
      type: Boolean,
      default: false
    },
    isFromIncome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let horizonalLinePlugin = {
      id: 'horizontalLine',
      afterDraw: this.afterDraw
    }
    return {
      horizonalLinePlugin
    }
  },
  methods: {
    afterDraw(chartInstance) {
      var yValue;
      var yScale = chartInstance.scales["y-axis-0"];
      var canvas = chartInstance.chart;
      var ctx = canvas.ctx;
      var index;
      var line;
      var style;
      if(this.isFromIncome) {
        chartInstance.options.legend.display = false;
      }
      if (chartInstance.options.horizontalLine) {

        for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
          line = chartInstance.options.horizontalLine[index];

          if (!line.style) {
            style = "#080808";
          } else {
            style = line.style;
          }

          if (line.y) {
            yValue = yScale.getPixelForValue(line.y);
          } else {
            yValue = 0;
          }
          ctx.lineWidth = 3;

          if (yValue) {
            window.chart = chartInstance;
            ctx.beginPath();
            ctx.moveTo(0, yValue);
            ctx.lineTo(canvas.width, yValue);
            ctx.strokeStyle = style;
            ctx.stroke();
          }

          if (line.text) {
            ctx.fillStyle = style;
            ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
          }
        }
        return;
      }
    },
  },
  beforeMount () {
    this.addPlugin(this.horizonalLinePlugin)
  },
  mounted () {
    if(this.chartInfo && this.chartInfo.labels && this.chartInfo.labels.length != 0){
      if(this.isFromSalaryChart == false) {
        if(this.typeChart == 'day'){
          for(let i = 0 ; i < this.chartInfo.labels.length; i++){
            this.chartInfo.labels[i] = changeFormatHelper(this.chartInfo.labels[i])
          }
        }
        if(this.typeChart == 'week'){
          for(let i = 0 ; i < this.chartInfo.labels.length; i++){
            let week_arr = this.chartInfo.labels[i].split(" ");
            this.chartInfo.labels[i] = changeFormatWeek(week_arr[0]) + " " + changeFormatWeek(week_arr[1]);
          }
        }
        if(this.typeChart == 'month'){
          for(let i = 0 ; i < this.chartInfo.labels.length; i++){
            this.chartInfo.labels[i] = this.chartInfo.labels[i].slice(0,3);
          }
        }
      }
      this.renderChart(
      this.chartInfo,
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            categoryPercentage: 0.5,
            barPercentage: 1
          }],
          yAxes: [{
            stacked: true
          }]
        }
      })
    }
  }
}
// import Vue from 'vue'
// import VueCharts from 'vue-chartjs'
// import { Bar, Line } from 'vue-chartjs'
// import { Bar } from 'vue-chartjs'


// const horizonalLinePlugin = {
//   id: 'horizontalLine',
//   afterDraw: function(chartInstance) {

//     var yValue;
//     var yScale = chartInstance.scales["y-axis-0"];
//     var canvas = chartInstance.chart;
//     var ctx = canvas.ctx;
//     var index;
//     var line;
//     var style;

//     if (chartInstance.options.horizontalLine) {

//       for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
//         line = chartInstance.options.horizontalLine[index];

//         if (!line.style) {
//           style = "#080808";
//         } else {
//           style = line.style;
//         }

//         if (line.y) {
//           yValue = yScale.getPixelForValue(line.y);
//         } else {
//           yValue = 0;
//         }
//         ctx.lineWidth = 3;

//         if (yValue) {
//           window.chart = chartInstance;
//           ctx.beginPath();
//           ctx.moveTo(0, yValue);
//           ctx.lineTo(canvas.width, yValue);
//           ctx.strokeStyle = style;
//           ctx.stroke();
//         }

//         if (line.text) {
//           ctx.fillStyle = style;
//           ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
//         }
//       }
//       return;
//     }
//   }
// }
// Vue.component('line-chart', {
//   extends: Bar,
//   beforeMount () {
//     this.addPlugin(horizonalLinePlugin)
//   },
//   mounted () {
//     this.renderChart({
//       labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August' , 'September' , 'October' , 'November' , 'December'],
//       datasets: [
//         {
//           label: 'Checked In',
//           backgroundColor: 'rgb(71, 137, 255)',
//           data: [40, 0 , 39, 10, 40, 39, 80, 40]
//         },
//         {
//           label: 'New Client',
//           backgroundColor: 'rgb(42, 102, 210)',
//           data: [40, 0 , 39, 10, 40, 39, 80, 40]
//         },
//       ]
//     }, {
//       responsive: true,
//       maintainAspectRatio: false,
//       scales: {
//         xAxes: [{
//           stacked: true,
//           categoryPercentage: 0.5,
//           barPercentage: 1
//         }],
//         yAxes: [{
//           stacked: true
//         }]
//       }
//     })
//   }

// })
</script>
